// 2026-09-27 US-010
import { RootState } from 'store/rootTypes';

export const LoyaltySelector = (state: RootState) => state.Loyalty;
